import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { _ConfigAdmin } from "../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { CardTaps } from "../../theme/Component/CardTaps";
import { SelectorOffice } from "../../bpm/config/Componentes/SelectorOffice";
import { AccountEditor } from "../../editor/AccountEditor";
import { BusinessRoleCatalog } from "../../admin/configuracion/functionalID/RolesComponents/BusinessRoleCatalog";
import { useDashboardStore } from "../../pages/hooks/useDashboardStore";
import { BpmServiceall } from "../../../core/services/BpmServiceall";
import { SelectFunctionalID } from "../../admin/configuracion/functionalID/SelectFunctionalID";
import { BasicButton } from "../../theme/Component/BasicButton";



export const RolesenArea = () => {

    const ConfigAdmin = useDataBean(_ConfigAdmin);
    const single = Singleton.getInstance();
    const [indexTap, setIndexTap] = useState(0);
    let taps = [
        { id: 0, name: 'Equipo de Trabajo', disable: false },
        { id: 1, name: 'Asignaciones', disable: false }
    ];
    const [confirm, setConfirm] = useState<any>({ name: 'Atención!', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [confirm2, setConfirm2] = useState<any>({ name: 'Confirmación', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [workersList, setWorkersList] = useState([])
    const [idOffice, setIdOffice] = useState(undefined);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [miBean, setMibean] = useState<any>({});
    const [modalAddRole, setModalAddRole] = useState<any>({ name: 'Agregar Rol', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [wroker, setWorker] = useState<any>({});
    const { setLoading } = useDashboardStore();
    const [funtional, setFuntional] = useState<number>(null);
    const bpmService = new BpmServiceall();
    useEffect(() => {
        // getLista();
    }, [])

    const getMemberList = () => {
        setLoading(true)
        bpmService.getWorkGroupMemberCatalog(funtional, idOffice)
            .subscribe((resp: any) => {
                setLoading(false)
                setWorkersList(resp.DataBeanProperties.ObjectValue)
            })
    }

    const create = () => {
        ConfigAdmin.setBean({

        });
        setModal({ ...modal, "view": true });
    }

    const addMember = (selectedMember: any) => {
        setLoading(true)
        bpmService.addWorkGroupMember(miBean.IDLn, selectedMember.IDAccount, idOffice)
            .subscribe((resp) => {
                setLoading(false)
                //console.log("Añadido", resp);
                getMemberList()
            })
    }

    const takeOutButton = () => {
        const botones = [
            { titulo: 'Retirar de la lista', icono: 'ri-file-user-line', visible: true, evento: () => { setConfirm2({ ...confirm2, 'view': true }) } },
            { titulo: 'Asignar rol al usuario', icono: 'ri-file-add-line', visible: true, evento: () => { setModalAddRole({ ...modalAddRole, 'view': true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const head = [
        { title: 'ID', property: 'IDEntailment', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Código del Manual de funciones', property: 'AppointmentManualCode', visible: true },
        { title: 'Manual de Funciones', property: 'AppointmentManualName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${ConfigAdmin.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Roles en Area">
            <div className="row">
                <div className="col-md-12">
                    {/* <BasicTable body={lista} head={head} rowSet={ConfigAdmin.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">


                        </div>
                    </Modal> */}

                    <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
                        {/* <PrintJson json={inboxList}/> */}
                        {indexTap === 0 &&
                            <div className="row">
                                <div className="col-md-12">
                                    <div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h4>{miBean.Name}</h4>
                                            </div>
                                            <div className="col-md-6">
                                                <SelectFunctionalID label="Unidad Organizacional" onChange={(e) => { setFuntional(e?.IDLn) }} />
                                            </div>
                                            <div className="col-md-6 justify-content-end">
                                                <SelectorOffice idSelector={idOffice} titulo="En la sucursal" onChange={(e: any) => { setIdOffice(e) }} />
                                            </div>
                                            <div className="col-md-6 justify-content-end">
                                                <AccountEditor disabled={idOffice == 0} idAccount={miBean.IDBoss} label="Añadir personal" onChange={addMember} />
                                            </div>
                                            <div className="col-md-4 mt-4">
                                                <BasicButton icon=" " eventClick={getMemberList}>Buscar</BasicButton>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 m-3 mt-5">
                                                <BasicTable listButtons={takeOutButton()} head={head} body={idOffice === 0 ? [] : workersList} rowSet={(bean: any) => {
                                                    setWorker(bean);
                                                    setModal({ ...modal, 'view': false });
                                                }} ></BasicTable>
                                            </div>
                                        </div></div>
                                </div>
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="row">
                                <div className="col-md-12">
                                    <p>Roles</p>
                                    <BusinessRoleCatalog IDLnFunctional={miBean.IDLn} />
                                </div>
                            </div>
                        }
                    </CardTaps>

                </div>

            </div>
        </BasicPage>
    )
}